import { useMemo, useState } from 'react';

export function useBoolean(initialState = false): readonly [
  boolean,
  {
    on: () => void;
    off: () => void;
    toggle: () => void;
  },
] {
  const [value, setValue] = useState(initialState);
  const setter = useMemo(() => {
    return {
      on: () => setValue(true),
      off: () => setValue(false),
      toggle: () => setValue((v) => !v),
    };
  }, []);
  return [value, setter];
}
